import styled from 'styled-components';
import { FONTS, COLORS } from '@ertelecom/ui-react/assets/js/constants';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 530px) {
    display: block;
    position: relative;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-color: ${COLORS.white};
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.11);
    cursor: pointer;
  }
`;

export const Text = styled.div`
    display: block;
    padding-right: 20px;
    ${FONTS.XS};
    color: ${COLORS.darkGrey};
    @media(max-width: 530px) {
        display: none;
    }
`;

export const Icons = styled.div`
    display: flex;
    height: 22px;
    flex-wrap: nowrap;
    transition: 0.5s;
    align-items: center;
    @media(max-width: 530px) {
        height: 30px;
        position: absolute;
        top: 0;
        bottom: 0;
        right: calc(100% + 16px);
        max-width: ${p => p.active ?  '165px' : '0px'};
        opacity: ${p => p.active ?  '1' : '0'};
        pointer-events: ${p => p.active ?  'auto' : 'none'};
        margin: auto 0;
        overflow: hidden;
    }
`;

export const Icon = styled.div`
    display: block;
    position: relative;
    width: 22px;
    cursor: pointer;
    margin-left: 14px;
    &:nth-child(1) {
        margin-left: 0;
    }
    svg {
        display: block;
        width: 100%;
    }
    @media(max-width: 530px) {
        width: 30px;
    }
`;

export const MobIcon = styled.div`
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 20px;
    height: 20px;
    margin: auto;
    transition: 0.5s;
    transform: rotate(${p => p.active ? '135deg' : '0deg'});
    @media(max-width: 530px) {
        display: block;
    }
    svg {
        display: ${p => p.active ? 'none' : 'block'};
        margin-left: -1px;
    }
    &:after, &:before {
        display: ${p => p.active ? 'block' : 'none'};
        position: absolute;
        content: '';
        background-color: ${COLORS.black};
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
    }
    &:after {
        width: 100%;
        height: 2px;
    }
    &:before {
        width: 2px;
        height: 100%;
    }
`;
